import { render, staticRenderFns } from "./CourseCardMaterialsRequirements.vue?vue&type=template&id=259c6c6c&scoped=true"
import script from "./CourseCardMaterialsRequirements.vue?vue&type=script&lang=js"
export * from "./CourseCardMaterialsRequirements.vue?vue&type=script&lang=js"
import style0 from "./CourseCardMaterialsRequirements.vue?vue&type=style&index=0&id=259c6c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259c6c6c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListIcon: require('/builds/marketing/abstracta.academy-website/components/ListIcon.vue').default})
